import { useEffect } from 'react'

/**
 * Custom hook to set the document title on mount
 * @param {string} title - Page title (will be appended with app name)
 * @param {string} [suffix] - Optional suffix (defaults to app name)
 */
export default function usePageTitle(title, suffix = 'Poll App') {
    useEffect(() => {
        const fullTitle = title ? `${title} | ${suffix}` : suffix
        document.title = fullTitle
    }, [title, suffix])
}
